import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  HospitalImgMasterCreateRequestDTO,
  HospitalImgMasterDeleteRequestDTO,
  HospitalImgMasterDTO,
  HospitalImgMasterList,
  HospitalImgMasterReadByIdRequestDTO,
  HospitalImgMasterReadByMasterIdRequestDTO,
  HospitalImgMasterReadByMasterType,
  HospitalImgMasterUpdateRequestDTO,
} from './hospital-img.interface';
import { Observable } from 'rxjs';
import {
  HospitalImgMaster_Create,
  HospitalImgMaster_Delete,
  HospitalImgMaster_ReadAll,
  HospitalImgMaster_ReadById,
  HospitalImgMaster_ReadByMasterId,
  HospitalImgMaster_ReadByMasterType,
  HospitalImgMaster_Update,
} from 'src/app/GlobalVariable/Hospital.GlobalVariable';

@Injectable({
  providedIn: 'root',
})
export class HospitalImgMasterService {
  constructor() {}

  http = inject(HttpClient);

  HospitalImgMaster_Create(
    data: HospitalImgMasterCreateRequestDTO
  ): Observable<HospitalImgMasterDTO> {
    return this.http.post<HospitalImgMasterDTO>(HospitalImgMaster_Create, data);
  }

  HospitalImgMaster_Update(
    data: HospitalImgMasterUpdateRequestDTO
  ): Observable<HospitalImgMasterDTO> {
    return this.http.post<HospitalImgMasterDTO>(HospitalImgMaster_Update, data);
  }

  HospitalImgMaster_Delete(
    data: HospitalImgMasterDeleteRequestDTO
  ): Observable<void> {
    return this.http.post<void>(HospitalImgMaster_Delete, data);
  }

  HospitalImgMaster_ReadAll(): Observable<HospitalImgMasterList> {
    return this.http.get<HospitalImgMasterList>(HospitalImgMaster_ReadAll);
  }

  HospitalImgMaster_ReadById(data: HospitalImgMasterReadByIdRequestDTO): Observable<HospitalImgMasterDTO> {
    return this.http.post<HospitalImgMasterDTO>(HospitalImgMaster_ReadById, data);
  };

  HospitalImgMaster_ReadByMasterId(data: HospitalImgMasterReadByMasterIdRequestDTO): Observable<HospitalImgMasterList> {
    return this.http.post<HospitalImgMasterList>(HospitalImgMaster_ReadByMasterId, data);
  };

  HospitalImgMaster_ReadByMasterType(data: HospitalImgMasterReadByMasterType) : Observable<HospitalImgMasterList> {
    return this.http.post<HospitalImgMasterList>(HospitalImgMaster_ReadByMasterType, data);
  }
}
